export default __webpack_public_path__ + "static/media/Oil.256.0fb7f79b.png";